import React from 'react'
import { PrimaryBtn } from '../Button/button'
import { Link } from 'react-router-dom'
import Button from '../SelectValue/Button'
const ModalCont = ({backbtn, title, cancelbtn, children, text, hide, handleClose, onSubmit}) => {
  const style = {
    backgroundColor : '#2948CE',
  }
  return (
    <div className='w-full max-h-[550px] overflow-scroll relative'>
      <header className='flex justify-between items-center py-5 px-3 bg-white shadow-sm w-full fixed top-0 left-0 h-[60px] z-10 rounded-lg'>
        <p className='cursor-pointer' id={hide}>
          <img src={backbtn} alt="" />
        </p>

        <h1 className='text-custom-black text-[18px] font-[700]'>
            {title}
        </h1>
        <Link className='cursor-pointer' onClick={handleClose}>
        <img src={cancelbtn} alt="" />
        </Link>

      </header>
      <div className='p-3 mt-[62px]'>
        <form onSubmit={onSubmit} className='pb-7'>
            {children}
            { onSubmit  &&
              <div className=' grid grid-cols-1'>
            <Button
              name={'Continue'}
            />
            </div>
            }
           
            
        </form>

        {/* <PrimaryBtn text={text} styling={`${style} w-full mt-3`} variant='contained'/> */}
      </div>
    </div>
  )
}

export default ModalCont
